<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    disabled?: boolean
    title: string
    active?: boolean
  }>(),
  {
    disabled: false,
    active: false
  }
)

const tabIndex = ref(null)

const addTab = inject<(tab: { title: string; index: number; disabled: boolean; active: any }) => number>('addTab')
const setTab = inject<(tab: { title: string; index: number; disabled: boolean; active: any }) => void>('setTab')
const currentTab = inject<number>('currentTab')

watch(props, () => {
  if (tabIndex.value === null) {
    return
  }

  setTab({
    title: props.title,
    index: tabIndex.value,
    disabled: props.disabled,
    active: props.active
  })
})

onMounted(() => {
  tabIndex.value = addTab({
    title: props.title,
    index: tabIndex.value,
    disabled: props.disabled,
    active: props.active
  })
})
</script>

<template>
  <div v-if="tabIndex === currentTab" class="w-full max-w-6xl px-5 py-8">
    <slot></slot>
  </div>
</template>
